<template>
  <div class="Contact-page" >
<headers :imageSrc="imageSrc"/>
<div class="contact-from">
  <!-- pc端 -->
  <div class="contact-from-left" v-if="isSmallScreen===false">
    <el-form ref="formName" :model="form" :rules="rules" label-width="80px" :label-position="labelPosition">
        <!-- <p class="from-p">个人信息</p> -->
        <div class="from-bro"></div>
      <el-row>
        <el-col :span="12">
      <el-form-item label="姓名" prop="name">
        <el-input type="text"  placeholder="请输入您的姓名" v-model="form.name" style="width: 90%;"></el-input>
      </el-form-item>
        <el-form-item label="手机号码" prop="mobile">
        <el-input type="text" placeholder="请输入您的手机号" v-model="form.mobile" style="width: 90%;"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="emil">
       <el-input type="text" placeholder="请输入您的邮箱" v-model="form.emil" style="width: 90%;"></el-input>
      </el-form-item>
        </el-col>
        <el-col :span="12">
      <el-form-item label="企业全称和部门" prop="qiye">
        <el-input type="text" placeholder="请输入您的企业全称和部门" v-model="form.qiye" style="width: 90%;"></el-input>
      </el-form-item>
      <el-form-item label="留言" prop="liu">
        <el-input type="textarea" placeholder="请描述您的需求" v-model="form.liu" style="width: 90%;"></el-input>
      </el-form-item>
        </el-col>
      </el-row>
      <el-form-item v-if="isshow">
        <el-button type="primary" @click="onSubmit">预约演示</el-button>
      </el-form-item>
      <el-form-item v-else>
        <el-button type="primary" style="background-color: #7abea2;" @click="onSubmit">预约演示</el-button>
      </el-form-item>
    </el-form>
  </div>
  <!-- 移动端 -->
  <div class="contact-from-left" v-else>
    <el-form ref="formName" :model="form" :rules="rules" label-width="80px" :label-position="labelPosition">
      <el-row>
        <el-col :span="24">
      <el-form-item label="姓名" prop="name">
        <el-input type="text"  placeholder="请输入您的姓名" v-model="form.name" style="width: 160%;"></el-input>
      </el-form-item>
        </el-col>
        <el-col :span="24">
      <el-form-item label="手机号码" prop="mobile">
        <el-input type="text" placeholder="请输入您的手机号" v-model="form.mobile" style="width: 160%;"></el-input>
      </el-form-item>
        </el-col>
        <el-col :span="24">
      <el-form-item label="邮箱" prop="emil">
       <el-input type="text" placeholder="请输入您的邮箱" v-model="form.emil" style="width: 160%;"></el-input>
      </el-form-item>
        </el-col>
        <el-col :span="24">
      <el-form-item label="企业全称和部门" prop="qiye">
       <el-input type="text" placeholder="请输入您的企业全称和部门" v-model="form.qiye" style="width: 160%;"></el-input>
      </el-form-item>
        </el-col>
        <el-col :span="24">
      <el-form-item label="留言" prop="liu">
        <el-input type="textarea" placeholder="请描述您的需求" v-model="form.liu" style="width: 160%;"></el-input>
       </el-form-item>
        </el-col>
      </el-row>
      <el-form-item v-if="isshow">
        <el-button type="primary" @click="onSubmit">预约演示</el-button>
      </el-form-item>
      <el-form-item v-else>
        <el-button type="primary" style="background-color: #7abea2;" @click="onSubmit">预约演示</el-button>
      </el-form-item>
    </el-form>
  </div>
  <!-- <div class="contact-from-right" v-if="isSmallScreen===false">
    <h4 @mouseover="yewu">业务咨询:  +86 400-638-5060</h4>
    <p class="kehu" @mouseover="kehu">客户服务:  support@ai4c3.com</p>
    <p class="gongsi" @mouseover="dizhi">公司地址:  上海市浦东新区纳贤路800号</p>
  </div> -->
</div>
<footers/>
</div>
</template>
<script>
import axios from 'axios'
import headers from '../../components/headers.vue'
import footers from '../../components/footers.vue'
export default {
  components: { headers, footers },
  data () {
    return {
      imageSrc: '',
      labelPosition: 'top',
      form: {
        name: '',
        mobile: '',
        emil: '',
        liu: '',
        qiye: '',
        bumen: ''
      },
      isshow: true,
      isSmallScreen: false,
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1(3[0-9]|4[5-9]|5[0-35-9]|6[56]|7[0-8]|8[0-9]|9[89])\d{8}$/, message: '请输入11位手机号', trigger: 'blur' }
        ],
        emil: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        liu: [
          { required: false, message: '请输入留言', trigger: 'blur' }
        ],
        qiye: [
          { required: true, message: '请输入部门和企业全称', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
      this.imageSrc = '../assets/image/lxwm.png'
    } else {
      this.isSmallScreen = false
      this.imageSrc = '../assets/image/lxwmbanner.png'
    }
  },
  created () {
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
      this.imageSrc = '../assets/image/lxwm.png'
    } else {
      this.isSmallScreen = false
      this.imageSrc = '../assets/image/lxwmbanner.png'
    }
  },
  watch: {
    form: {
      deep: true,
      handler (value) {
      // 定义必填字段名称
        const requiredFields = ['name', 'mobile', 'email', 'qiye']
        // 遍历必填字段，检查是否全部完成
        const isRequiredFieldsCompleted = requiredFields.every(field => value[field] !== '')
        if (isRequiredFieldsCompleted) {
        // 必填字段全部完成的逻辑
          this.isshow = false
        } else {
        // 必填字段未全部完成的逻辑
          this.isshow = true
        }
      }
    }
  },
  methods: {
    // 鼠标移入
    yewu () {
      // 0px solid #ededed
      // 4px solid #82c2c3
      const res1 = document.querySelector('.contact-from-right h4')
      const res2 = document.querySelector('.contact-from-right  .kehu')
      const res3 = document.querySelector('.contact-from-right  .gongsi')
      res1.style.color = 'black'
      res1.style.borderLeft = '4px solid #82c2c3'
      res2.style.color = '#aeaeae'
      res2.style.borderLeft = '0px solid #ededed'
      res3.style.color = '#aeaeae'
      res3.style.borderLeft = '0px solid #ededed'
    },
    kehu () {
      const res1 = document.querySelector('.contact-from-right h4')
      const res2 = document.querySelector('.contact-from-right  .kehu')
      const res3 = document.querySelector('.contact-from-right  .gongsi')
      res1.style.color = '#aeaeae'
      res1.style.borderLeft = '0px solid #ededed'
      res2.style.color = 'black'
      res2.style.borderLeft = '4px solid #82c2c3'
      res3.style.color = '#aeaeae'
      res3.style.borderLeft = '0px solid #ededed'
    },
    dizhi () {
      const res1 = document.querySelector('.contact-from-right h4')
      const res2 = document.querySelector('.contact-from-right  .kehu')
      const res3 = document.querySelector('.contact-from-right  .gongsi')
      res1.style.color = '#aeaeae'
      res1.style.borderLeft = '0px solid #ededed'
      res2.style.color = '#aeaeae'
      res2.style.borderLeft = '0px solid #ededed'
      res3.style.color = 'black'
      res3.style.borderLeft = '4px solid #82c2c3'
    },
    // 表单
    onSubmit () {
      // if (this.form.name && this.form.mobile && this.form.emil && this.form.qiye) {
      this.$refs.formName.validate(async (valid) => {
        if (valid) {
          await axios.post('https://saas.ai4c3.com/api/website/retention', {
            userName: this.form.name,
            phone: this.form.mobile,
            email: this.form.emil,
            leaveMessage: this.form.liu,
            company: this.form.qiye
            // dept: this.form.bumen
          }).then(response => {
            if (response.data.data) {
              this.$message({
                message: '提交表单成功',
                type: 'success'
              })
              this.form = {
                name: '',
                mobile: '',
                emil: '',
                liu: '',
                // bumen: '',
                qiye: ''
              }
            }
          }).catch(error => {
            console.log(error)
            this.$message({
              message: '提交表单失败',
              type: 'error'
            })
            this.form = {
              name: '',
              mobile: '',
              emil: '',
              liu: '',
              // bumen: '',
              qiye: ''
            }
          })
        } else {
          // console.log('error submit!!')
          this.$message.error('请完善表单')
          return false
        }
      })
      // }
    }
  }
}

</script>

<style scoped lang="scss">
input:focus {
  transform: scale(1);
}
 .contact-d{
    position: absolute;
    left: 50%;
    top: 62%;
    transform: translateX(-50%);
    width: 100%;
    height: 80px;
    border-bottom: 1px solid #d6d5d5 ;
  }
  .contact-p{
    text-align: center;
    font-size: 30px;
  }
  .contact-w{
    text-align: center;
    margin-top: 5px;
    color: #aeaeae;
  }
  .contact-from{
    position: relative;
    left: 0;
    top: 0;
    display: flex;
    flex-direction: row;
    margin: 4% 160px;
  }
  .contact-from-left{
    width: 73%;
    margin-left: 15%;
  }
  .contact-from-right{
    height: 103px;
    margin-left: 30px;
    margin-top: 20px;
    border-left: 2px solid #ededed;
    z-index: 10;
    h4{
      position: absolute;
      left: 64.2%;
      top: 5%;
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 15px;
      border-left: 4px solid #82c2c3;
      color: black;
      padding-left: 14px;
      z-index: 999;
    }
    .kehu{
      position: absolute;
      left: 64.2%;
      top: 14%;
      color: #aeaeae;
      margin-bottom: 15px;
      padding-left: 17px;
      z-index: 999;
    }
    .gongsi{
      position: absolute;
      left: 64.2%;
      top: 23%;
      color: #aeaeae;
      margin-bottom: 15px;
      padding-left: 17px;
      z-index: 999;
    }

  }
  .from-p{
    margin-bottom: 10px;
    font-size: 18px;
    margin-left:20px ;
  }
  .from-bro{
    border-bottom: 1px solid #d6d5d5;
    margin-left:20px ;
    margin-right:48px ;
  }
  .el-input[type='textarea'] {
  height: 150px;
  }
  ::v-deep{
    .el-textarea__inner{
     min-height: 150px !important;
     height: 158px;
    }
    .el-form-item__label{
      font-size: 16px;
    }
    .el-form-item{
      margin-top: 20px;
      margin-left: 20px;
    }
    .el-form-item__content{
      margin-top: -10px;
      .el-input__inner{
        height: 48px;
        line-height: 48px;
      }
    }
    .el-button--primary{
      margin: 35px auto;
      border: 1px solid #cbcccd ;
      position: absolute;
      left: 48%;
      transform: translate(-50%);
      top: 0;
      width: 250px;
      height: 57px;
      background-color: #cbcccd ;
      font-size: 18px;
      margin-bottom: 87px;
      border-radius:50px;
    }
  }
 @media screen and (min-width: 1920px) {
   .contact-d{
    position: absolute;
    left: 50%;
    top: 65%;
    transform: translateX(-50%);
    width: 100%;
    height: 90px;
    border-bottom: 1px solid #d6d5d5 ;
  }
  .contact-p{
    text-align: center;
    font-size: 30px;
    margin-bottom:40px ;
  }
  .contact-w{
    text-align: center;
    margin-top: -30px;
    color: #aeaeae;
  }
  .contact-from{
    display: flex;
    flex-direction: row;
    // margin: 285px auto;
    margin: 79px auto;
    width: 1210px;
  }
  .contact-from-left{
    width: 900px;
    margin-left:14% ;
  }
  .contact-from-right{
    width: 400px;
    height: 103px;
    margin-left: 30px;
    margin-top: 20px;
    border-left: 2px solid #ededed;
    position: relative;
    h4{
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 15px;
      color: black;
      border-left: 4px solid #82c2c3;
      padding-left: 14px;
      position: absolute;
      left: -2px;
      top: -2px;
      z-index: 1
    }
    .kehu{
      color: #aeaeae;
      margin-bottom: 15px;
      padding-left: 17px;
      position: absolute;
      left: -2px;
      top: 40px;
      z-index: 1
    }
    .gongsi{
      color: #aeaeae;
      margin-bottom: 15px;
      padding-left: 17px;
      position: absolute;
      left: -2px;
      top: 80px;
      z-index: 1
    }

  }
  .from-p{
    margin-bottom: 10px;
    font-size: 18px;
    margin-left:20px ;
  }
  .from-bro{
    border-bottom: 1px solid #d6d5d5;
    margin-left:20px ;
    margin-right: 43px;
  }
  .el-input[type='textarea'] {
  height: 150px;
  }
  ::v-deep{
    .el-textarea__inner{
     min-height: 150px !important;
     height: 156px;
    }
    .el-form-item__label{
      font-size: 16px;
    }
    .el-form-item{
      margin-top: 20px;
    }
    .el-form-item__content{
      margin-top: -10px;
      .el-input__inner{
        height: 48px;
        line-height: 48px;
      }
    }
    .el-button--primary{
      margin: 23px auto;
      // border: 1px solid #82c2c3 ;
      margin-left:0% ;
      width: 250px;
      height: 57px;
      background-color: #cbcccd ;
      font-size: 18px;
      margin-bottom: 87px;
      border-radius:50px ;
    }
  }
 }
 @media screen and (max-width: 1000px) and (min-width: 768px) {
    .contact-d{
    position: absolute;
    left: 50%;
    top: 63%;
    transform: translateX(-50%);
    width: 100%;
    height: 132px;
    border-bottom: 1px solid #d6d5d5 ;
  }
  .contact-p{
    text-align: center;
    font-size: 30px;
  }
  .contact-w{
    text-align: center;
    margin-top: 10px;
    color: #aeaeae;
  }
  .contact-from{
    display: flex;
    flex-direction: row;
    margin: 66px auto;
    width: 100%;
  }
  .contact-from-left{
    width: 55%;
    margin-left: 6%;
  }
  .from-p{
    margin-bottom: 10px;
    font-size: 18px;
  }
  .from-bro{
    border-bottom: 1px solid #d6d5d5;
  }
  .el-input[type='textarea'] {
  height: 150px;
  }
  ::v-deep{
    .el-textarea__inner{
     min-height: 150px !important;
     height: 150px;
    }
    .el-form-item__label{
      font-size: 16px;
    }
    .el-form-item{
      margin-top: 20px;
      margin-left:20px ;
    }
    .el-form-item__content{
      margin-top: -10px;
      .el-input__inner{
        height: 48px;
        line-height: 48px;
      }
    }
    .el-button--primary{
      margin: 0 auto;
      position: absolute;
      left:80%;
      transform: translate(-50%);
      top: 0;
      width: 250px;
      height: 57px;
      background-color: #cbcccd ;
      font-size: 18px;
      margin-bottom: 87px;
    }
  }
 }
 @media screen and (max-width: 1440px) and (min-width: 1000px) {
   .contact-d{
    position: absolute;
    left: 50%;
    top: 70%;
    // top: 118%;
    transform: translateX(-50%);
    width: 100%;
    height: 90px;
    border-bottom: 1px solid #d6d5d5 ;
  }
  .contact-p{
    text-align: center;
    font-size: 30px;
    margin-bottom:30px ;
  }
  .contact-w{
    text-align: center;
    margin-top: -15px;
    color: #aeaeae;
  }
  .contact-from{
    position: relative;
    left: 0;
    top: 0;
    display: flex;
    flex-direction: row;
    // margin: 265px 160px;
    margin: 84px 160px;
  }
  .contact-from-left{
    // width: 55%;
    // margin-left: 7%;
    width: 76%;
    margin-left: 13%;
  }
  .contact-from-right{
    width: 300px;
    height: 103px;
    margin-left: 30px;
    margin-top: 20px;
    border-left: 2px solid #ededed;
    h4{
      position: absolute;
      left: 64.6%;
      top: 5%;
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 15px;
      border-left: 4px solid #82c2c3;
      color: black;
      padding-left: 14px;
      z-index: 999;
    }
    .kehu{
      position: absolute;
      left: 64.6%;
      top: 14%;
      color: #aeaeae;
      margin-bottom: 15px;
      padding-left: 17px;
      z-index: 999;
    }
    .gongsi{
      position: absolute;
      left: 64.6%;
      top: 23%;
      color: #aeaeae;
      margin-bottom: 15px;
      padding-left: 17px;
      z-index: 999;
    }

  }
  .from-p{
    margin-bottom: 10px;
    font-size: 18px;
  }
  .from-bro{
    border-bottom: 1px solid #d6d5d5;
    margin-right:40px ;
  }
  .el-input[type='textarea'] {
  height: 150px;
  }
  ::v-deep{
    .el-textarea__inner{
     min-height: 150px !important;
     height: 158px;
    }
    .el-form-item__label{
      font-size: 16px;
    }
    .el-form-item{
      margin-top: 20px;
      margin-left: 20px;
    }
    .el-form-item__content{
      margin-top: -10px;
      .el-input__inner{
        height: 48px;
        line-height: 48px;
      }
    }
    .el-button--primary{
      margin: 100px auto;
      position: absolute;
      // left: 83%;
      left: 48%;
      transform: translate(-50%);
      top: -65px;
      width: 250px;
      height: 57px;
      background-color: #cbcccd ;
      font-size: 18px;
      margin-bottom: 87px;
      border-radius:50px ;
    }
  }
 }
 @media screen and (max-width: 1600px) and (min-width: 1441px) {
   .contact-d{
    position: absolute;
    left: 50%;
    top: 70%;
    // top: 118%;
    transform: translateX(-50%);
    width: 100%;
    height: 90px;
    border-bottom: 1px solid #d6d5d5 ;
  }
  .contact-p{
    text-align: center;
    font-size: 30px;
    margin-bottom:30px ;
  }
  .contact-w{
    text-align: center;
    margin-top: -15px;
    color: #aeaeae;
  }
  .contact-from{
    position: relative;
    left: 0;
    top: 0;
    display: flex;
    flex-direction: row;
    margin: 77px 160px;
  }
  .contact-from-left{
    width: 73%;
    margin-left: 14%;
  }
  .contact-from-right{
    width: 300px;
    height: 103px;
    margin-left: 30px;
    margin-top: 20px;
    border-left: 2px solid #ededed;
    h4{
      position: absolute;
      left: 64.3%;
      top: 5%;
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 15px;
      border-left: 4px solid #82c2c3;
      color: black;
      padding-left: 14px;
      z-index: 999;
    }
    .kehu{
      position: absolute;
      left: 64.3%;
      top: 14%;
      color: #aeaeae;
      margin-bottom: 15px;
      padding-left: 17px;
      z-index: 999;
    }
    .gongsi{
      position: absolute;
      left: 64.3%;
      top: 23%;
      color: #aeaeae;
      margin-bottom: 15px;
      padding-left: 17px;
      z-index: 999;
    }

  }
  .from-p{
    margin-bottom: 10px;
    font-size: 18px;
  }
  .from-bro{
    border-bottom: 1px solid #d6d5d5;
    margin-right:45px ;
  }
  .el-input[type='textarea'] {
  height: 157px;
  }
  ::v-deep{
    .el-textarea__inner{
     min-height: 150px !important;
     height: 150px;
    }
    .el-form-item__label{
      font-size: 16px;
    }
    .el-form-item{
      margin-top: 20px;
      margin-left: 20px;
    }
    .el-form-item__content{
      margin-top: -10px;
      .el-input__inner{
        height: 48px;
        line-height: 48px;
      }
    }
    .el-button--primary{
      margin: 42px auto;
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      top: 0;
      width: 250px;
      height: 57px;
      background-color: #cbcccd ;
      font-size: 18px;
      margin-bottom: 87px;
      border-radius:50px ;
    }
  }
 }
 @media screen and (max-width: 375px) {
   .contact-d{
    position: absolute;
    left: 50%;
    top: 53%;
    transform: translateX(-50%);
    width: 100%;
    height: 80px;
    border-bottom: 1px solid #d6d5d5 ;
  }
  .contact-p{
    text-align: center;
    font-size: 15px;
  }
  .contact-w{
    text-align: center;
    margin-top: 11px;
    color: #aeaeae;
  }
  .contact-from{
    display: flex;
    flex-direction: row;
    margin: 24px auto;
    width: 373px;
    height: 280px;
  }
  .contact-from-left{
    width: 210px;
    margin-left: 10px;
  }
  .contact-from-right{
    width: 100px;
    height: 103px;
    margin-left: 10px;
    margin-top: 10px;
    border-left: 1px solid #aeaeae;
    h4{
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 10px;
      border-left: 3px solid #82c2c3;
      padding-left: 10px;
    }
    p{
      font-size: 14px;
      color: #aeaeae;
      margin-bottom: 15px;
      padding-left: 13px;
    }

  }
  .from-p{
    margin-bottom: 10px;
    font-size: 12px;
  }
  .from-bro{
    border-bottom: 1px solid #d6d5d5;
  }
  .el-input[type='textarea'] {
  height: 150px;
  }
  ::v-deep{
    .el-textarea__inner{
     min-height: 100px !important;
     height: 100px;
    }
    .el-form-item__label{
      font-size: 12px;
    }
    .el-form-item{
      margin-top: -5px;
    }
    .el-form-item__content{
      margin-top: -20px;
      .el-input__inner{
        padding-left:10px ;
        height: 44px;
        line-height: 38px;
      }
    }
    .el-button--primary{
      margin: 40px auto;
      margin-left:33% ;
      // border: 1px solid #82c2c3 ;
      width: 305px;
      height: 45px;
      background-color: #cbcbcb ;
      font-size: 14px;
      margin-bottom: 87px;
      border-radius: 0px;
    }
  }
 }
 @media screen and (max-width: 414px) and (min-width: 391px) {
    input:focus {
      transform: scale(1);
   }
    .contact-d{
    margin-top:50px ;
    position: relative;
    left: 50%;
    top: 47%;
    transform: translateX(-50%);
    width: 100%;
    height: 76px;
    border-bottom: 1px solid #d6d5d5 ;
  }
  .contact-p{
    text-align: center;
    font-size: 20px;
    font-weight: 700;
  }
  .contact-w{
    text-align: center;
    margin-top: 6px;
    color: #aeaeae;
  }
  .contact-from{
    display: flex;
    flex-direction: row;
    margin: 47px auto;
    width: 373px;
    height: 280px;
  }
  .contact-from-left{
    width: 210px;
    margin-left: 10px;
  }
  .contact-from-right{
    width: 100px;
    height: 103px;
    margin-left: 10px;
    margin-top: 10px;
    border-left: 1px solid #aeaeae;
    h4{
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 10px;
      border-left: 3px solid #82c2c3;
      padding-left: 10px;
    }
    p{
      font-size: 14px;
      color: #aeaeae;
      margin-bottom: 15px;
      padding-left: 13px;
    }

  }
  .from-p{
    margin-bottom: 10px;
    font-size: 12px;
  }
  .from-bro{
    border-bottom: 1px solid #d6d5d5;
  }
  .el-input[type='textarea'] {
  height: 150px;
  }
  ::v-deep{
    .el-textarea__inner{
     padding-left:10px ;
     min-height: 100px !important;
     height: 100px;
    }
    .el-form-item__label{
      font-size: 12px;
    }
    .el-form-item{
      margin-top: 0px;
    }
    .el-form-item__content{
      margin-top: -20px;
      .el-input__inner{
        padding-left:10px ;
        height: 44px;
        line-height: 40px;
      }
    }
    .el-button--primary{
      margin: 30px auto;
      margin-left:32% ;
      // border: 1px solid #82c2c3 ;
      width: 160%;
      height: 44px;
      background-color: #cbcbcb;
      font-size: 14px;
      margin-bottom: 87px;
      border-radius: 0px;
    }
  }
 }
 @media screen and (max-width: 390px) and (min-width: 376px) {
   .contact-d{
    margin-top:50px ;
    position: relative;
    left: 50%;
    top: 47%;
    transform: translateX(-50%);
    width: 100%;
    height: 76px;
    border-bottom: 1px solid #d6d5d5 ;
  }
  .contact-p{
    text-align: center;
    font-size: 20px;
    font-weight: 700;
  }
  .contact-w{
    text-align: center;
    margin-top: 7px;
    color: #aeaeae;
  }
  .contact-from{
    display: flex;
    flex-direction: row;
    margin: 40px auto 20px;
    width: 373px;
    height: 280px;
  }
  .contact-from-left{
    width: 210px;
    margin-left: 10px;
  }
  .contact-from-right{
    width: 100px;
    height: 103px;
    margin-left: 10px;
    margin-top: 10px;
    border-left: 1px solid #aeaeae;
    h4{
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 10px;
      border-left: 3px solid #82c2c3;
      padding-left: 10px;
    }
    p{
      font-size: 14px;
      color: #aeaeae;
      margin-bottom: 15px;
      padding-left: 13px;
    }

  }
  .from-p{
    margin-bottom: 10px;
    font-size: 12px;
  }
  .from-bro{
    border-bottom: 1px solid #d6d5d5;
  }
  .el-input[type='textarea'] {
  height: 150px;
  }
  ::v-deep{
    .el-textarea__inner{
     padding-left:10px ;
     min-height: 100px !important;
     height: 100px;
    }
    .el-form-item__label{
      font-size: 12px;
      margin-bottom: 10px; ;
    }
    .el-form-item .is-required{
      margin-top:-6px ;
    }
    .el-form-item{
      margin-top: -6px;
    }
    .el-form-item__content{
      margin-top: -30px;
      .el-input__inner{
        padding-left:10px ;
        height: 48px;
        line-height: 40px;
      }
    }
    .el-button--primary{
      margin: 50px auto;
      margin-left:32% ;
      width: 160%;
      height: 45px;
      background-color: #cbcbcb;
      font-size: 14px;
      margin-bottom: 87px;
      border-radius: 0px;
    }
  }
 }
 @media screen and (max-width: 767px) and (min-width: 415px) {
    .contact-d{
    margin-top:50px ;
    position: relative;
    left: 50%;
    top: 47%;
    transform: translateX(-50%);
    width: 100%;
    height: 76px;
    border-bottom: 1px solid #d6d5d5 ;
  }
  .contact-p{
    text-align: center;
    font-size: 20px;
    font-weight: 700;
  }
  .contact-w{
    text-align: center;
    margin-top: 12px;
    color: #aeaeae;
  }
  .contact-from{
    display: flex;
    flex-direction: row;
    margin: 56px auto;
    width: 373px;
    height: 280px;
  }
  .contact-from-left{
    width: 210px;
    margin-left: 10px;
  }
  .contact-from-right{
    width: 100px;
    height: 103px;
    margin-left: 10px;
    margin-top: 10px;
    border-left: 1px solid #aeaeae;
    h4{
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 10px;
      border-left: 3px solid #82c2c3;
      padding-left: 10px;
    }
    p{
      font-size: 14px;
      color: #aeaeae;
      margin-bottom: 15px;
      padding-left: 13px;
    }

  }
  .from-p{
    margin-bottom: 10px;
    font-size: 12px;
  }
  .from-bro{
    border-bottom: 1px solid #d6d5d5;
  }
  .el-input[type='textarea'] {
  height: 150px;
  }
  ::v-deep{
    .el-textarea__inner{
     padding-left:10px ;
     min-height: 100px !important;
     height: 100px;
    }
    .el-form-item__label{
      font-size: 12px;
    }
    .el-form-item{
      margin-top: 0px;
    }
    .el-form-item__content{
      margin-top: -20px;
      .el-input__inner{
        padding-left:10px ;
        height: 40px;
        line-height: 40px;
      }
    }
    .el-button--primary{
      margin: 30px auto;
      margin-left:33% ;
      width: 160%;
      height: 40px;
      background-color: #cbcbcb ;
      font-size: 14px;
      margin-bottom: 87px;
      border-radius: 0px;
    }
  }
 }
</style>
